<template>
  <section>
    <div
      :class="[
        'store-locator',
        { 'store-locator--opened': opened }
      ]"
    >
      <div class="content">
        <div class="description">
          {{ description }}
        </div>

        <StoreForm
          class="form"
          @searchMap="searchMap"
        />

        <ul class="coins">
          <li
            v-for="coin in coins"
            :key="coin"
            :class="['coins__coin', coin]"
          />
        </ul>

        <button
          class="switch-map picto-store-locator-arrow"
          @click="opened = !opened"
        />
      </div>

      <div
        v-show="opened"
        class="map"
      >
        <StoreMap :results="results" />
      </div>
    </div>
  </section>
</template>

<script>
import StoreForm from '@/components/store/StoreForm.vue';
import StoreMap from '@/components/store/StoreMap.vue';

export default {
  components: {
    StoreForm,
    StoreMap,
  },

  data() {
    return {
      mapRef: null,
      results: null,
      opened: false,
    };
  },

  computed: {
    description() {
      return this.$store.state.config.store.description;
    },

    coins() {
      return this.$store.state.config.store.coins || [];
    },
  },

  methods: {
    searchMap(results) {
      this.results = results;
      this.$data.opened = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  row-gap: 5px;

  padding: 20px 25px 20px 20px;
  background-color: #FFF3E3;
  border-radius: 4px;

  +desktop() {
    padding-left: 40px;
    padding-right: 35px;
  }

  +above(xl) {
    padding-left: 60px;
  }

  .store-locator--opened & {
    border-radius: 4px 4px 0 0;
  }
}

.description {
  @extends $txt-store-locator-title;
}

.form {
  margin-right: auto;
  height: 40px;

  >>> .map-input {
    @extends $txt-store-locator-input;
    width: 186px;
    height: 100%;
    padding: 0 10px;

    background: #FFFFFF;
    border: 1px solid #000000;
    border-radius: 4px 0px 0px 4px;
  }

  >>> .search {
    @extends $txt-store-locator-submit;
    width: 40px;
    height: 100%;
    color: white;

    background: #000000;
    border: 1px solid #000000;
    border-radius: 0px 4px 4px 0px;
    cursor: pointer;
  }
}

.coins {
  display: none;

  +desktop() {
    display: flex;
    flex-direction: row-reverse;
  }

  &__coin {
    display: none;
    margin-left: -20px;

    &:nth-child(-n+4) { display: block; }

    +above(xl) { display: block; }
  }
}

.switch-map {
  cursor: pointer;

  .store-locator--opened & {
    transform: rotate(180deg);
  }
}

.map {
  height: 340px;
  border-radius: 0px 0px 6px 6px;
  overflow: hidden;

  +desktop() { height: 480px; }
}
</style>
